// extracted by css-extract-rspack-plugin
export default {"content":"_e2976683","text":"_43180c17","linkText":"_d09c4977"};